import { html } from "lit";
import { u } from "@converse/headless";

export default (embed_path, url, hide_url) => {
    const { hostname } = u.getURL(url);
    return html`<figure><iframe style="border-radius:12px" src="https://embed.music.apple.com/${embed_path}" width="100%" height="175" frameborder="0" allowfullscreen="" allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture" loading="lazy"></iframe>${hide_url ? "" : html`<a target="_blank" rel="noopener" title="${url}" href="${url}">${hostname}</a>`}</figure>`;
};
